import {
  type TableColumnFormatUptime,
  formatUptimeCellValue,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { maybeWrapNonEmptyWithLink } from 'components/Table/cells/helpers/maybeWrapWithLink';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderUptimeCell = <TRow,>(
  format: TableColumnFormatUptime<TRow>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const value = getValueFromKeyOfType(row, format.field);

  const content = pipe(
    value,
    option.fromNullable,
    option.map((number) =>
      number < 0 ? number.toString() : formatUptimeCellValue(number),
    ),
    option.toNullable,
    maybeWrapNonEmptyWithLink(
      row,
      severity !== null,
      format.createLinkProps,
      !context.disableLinks,
    ),
  );

  return {
    content,
  };
};
